import React, { Component } from 'react';
import { connect } from 'react-redux';
import { updateAddress } from '../../../../actions/personalInfoAction';
import {isMobile} from 'react-device-detect';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import AddressFields from '../../../../components/Address/AddressFields';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import { ADDRESS } from '../../../../utils/FieldTypes';

class InlineEditCurrentAddress extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.populateAddressFields = this.populateAddressFields.bind(this);
    this.validateField = this.validateField.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.setManualEntry = this.setManualEntry.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  handleChange(event) {
    this.props.handleChange(ADDRESS, event);
  }
  validateField(event) {
    this.props.validateField(ADDRESS, event);
  }
  onClickSave(event) {
    event.preventDefault();
    if(this.props.manualEntry) {
      this.props.validateFields(ADDRESS, ["address1", "address2", "city", "province", "postalCode"], (isValid) => {
        if(isValid) {        
          this.props.updateAddress(this.props.address1, this.props.address2, this.props.city, this.props.province, this.props.postalCode, true);
          this.toggleEdit();
        }
        else {
          this.setState({
            saveDialogOpen: false
          })
        }
      });
    }
    else {
      this.props.handleAutocompleteChange(ADDRESS,{
        homeAddress: {
          isInvalid: true,
          message: "Oops, home address is a required field"
        }
      });
      this.setState({
        saveDialogOpen: false
      })
    }
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(ADDRESS);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }  
  cancelEdit() {
    if( this.props.address1 === this.props.savedAddress.address1 &&
        this.props.address2 === this.props.savedAddress.address2 &&
        this.props.city === this.props.savedAddress.city &&
        this.props.province === this.props.savedAddress.province &&
        this.props.postalCode === this.props.savedAddress.postalCode &&
        this.props.manualEntry) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  populateAddressFields(addressFields) {
    this.props.populateAddressFields("address", addressFields);
  }
  setManualEntry(value) {
    this.props.setManualEntry(ADDRESS, value);
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let address = `${this.props.savedAddress.address1}, ${(this.props.savedAddress.address2 !== "") ? this.props.savedAddress.address2 + ', ' : ""}${this.props.savedAddress.city}, ${this.props.savedAddress.province}, ${this.props.savedAddress.postalCode}`;

    return (
      <div className="review-inline-edit">
        <StaticField label="Home Address" value={address} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />  
        <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
          <AddressFields {...this.props} handleChange={this.handleChange} populateAddressFields={this.populateAddressFields} validateField={this.validateField} setManualEntry={this.setManualEntry} autoFocus={!isMobile} />
        </InlineEdit>
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Address" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
  //...state.personalInfo.address
})

const mapDispatchToProps = dispatch => ({
  updateAddress: (address1, address2, city, province, postalCode, individuallySet) => dispatch(updateAddress(address1, address2, city, province, postalCode, individuallySet))
})

InlineEditCurrentAddress.defaultProps= {
  savedAddress: {
    address1: ""
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(InlineEditCurrentAddress);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/Address/CurrentAddress.js